import { SharedState } from '@trello/shared-state';

export const aiBoardPromptLoadingGradientState = new SharedState<boolean>(
  false,
);
